import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';
import { Award, Palette, Shield, Heart } from 'lucide-react';

const iconMap = {
  Award, Palette, Shield, Heart
};

const AboutUs = () => {
  const { content } = useSiteContent();
  const features = content.about_features || [];

  return (
    <section id="onas" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-black text-[#2D4A5E] mb-6">
              {content.about_title?.split(' ')[0]} <span className="text-[#4CAF50]">{content.about_title?.split(' ').slice(1).join(' ')}</span>
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              {content.about_text}
            </p>
            
            {features.length > 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {features.map((feature, index) => {
                  const Icon = iconMap[feature.icon] || Award;
                  return (
                    <div key={index} className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-full bg-[#4CAF50]/10 flex items-center justify-center flex-shrink-0">
                        <Icon className="w-5 h-5 text-[#4CAF50]" />
                      </div>
                      <div>
                        <h4 className="font-semibold text-[#2D4A5E] mb-1">{feature.title}</h4>
                        <p className="text-sm text-gray-500">{feature.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={content.about_image || content.gallery_images?.[1]?.url || content.gallery_images?.[0]?.url}
                alt="Profesionalno barvanje"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#4CAF50]/20 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#2D4A5E]/20 rounded-full blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
